import { render, staticRenderFns } from "./CallMeBack.vue?vue&type=template&id=d3520cc6&scoped=true&"
import script from "./CallMeBack.vue?vue&type=script&lang=js&"
export * from "./CallMeBack.vue?vue&type=script&lang=js&"
import style0 from "./CallMeBack.vue?vue&type=style&index=0&id=d3520cc6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3520cc6",
  null
  
)

export default component.exports